<template>
	<div class="content">
		<div class="tableTit">
			<p class="tabtitBg"></p>
			<h6>字典管理</h6>
			<el-button class="titBtn" type="primary" icon="el-icon-plus" @click="addClick()">添加字典</el-button>
			<el-button class="titBtn" type="success" @click="reset" icon="el-icon-refresh">重置</el-button>
			
			<el-button class="titBtn" type="success" icon="el-icon-search" @click="query">搜索</el-button>

			
			<el-input class="querys" v-model.trim="typename" placeholder="名称"></el-input>
		</div>
		<div class="tabBody">
			<el-table :data="tabledata" :height="tableHeight" @row-click="rowClick" highlight-current-row border row-key="id" :tree-props="{children: 'children'}" :header-cell-style="{background:'rgba(49,130,222,0.1)'}">

				<el-table-column type="index" align="center" width="45" label="序号"></el-table-column>
				<el-table-column prop="type" label="字段类型"></el-table-column>
				<el-table-column prop="name" label="字典名称" align="center"></el-table-column>
				<el-table-column prop="code" label="字典值" align="center"></el-table-column>
				
				<el-table-column prop="" label="操作" width="200" align="center">
					<template slot-scope="scope">
						<el-button class="tableedit" type="success" icon="el-icon-plus" @click="addchild(scope.row,scope.$index)">新增子分类</el-button>
						<el-button type="success" class="tableedit" icon="el-icon-edit" circle @click="edit(scope.row,scope.$index)"></el-button>
						<el-button type="warning" class="tableedit" icon="el-icon-delete" circle @click="deletes(scope.row,scope.$index)"></el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		
		<dictionpopup v-if="dialogVisible == true" :mystate="Addsid" @getcancel="Getcancel" @adddata="Adddata" ></dictionpopup>

	</div>
</template>

<script>
	import dictionpopup from "./popup/dictionpopup.vue";
	import { dictionlist,dictiondelete } from "@/api/api";
	
	export default {

		data() {
			return {
				tabledata: [],
				tableHeight: window.innerHeight - 180,
				total: 0,
				pageSize: 20, //每页多少条数据分页
				pageNum: 0, //当前页
				pageNums: null,
				typename: '',
				dw: '',
				dialogVisible: false,
				Addsid: [],
				row: null,
			}
		},
		components: {

			dictionpopup
		},
		mounted() {
			this.list();
		},
		methods: {
			reset(){
				this.list()
			},
			query(){
				dictionlist({name:this.typename}).then((res)=>{
					console.log(res)
					this.tabledata = res.data;
				})
			},
			list(){
				
				dictionlist({}).then((res)=>{
					console.log(res)
					this.tabledata = res.data;
				})
			},
			
			addClick() {
				this.dialogVisible = true;
				this.Addsid = ["xz"];
			},
			Getcancel(data) {
				this.dialogVisible = data.dialogVisible;
			},
			Adddata(data) {
				this.dialogVisible = data.dialogVisible;
				this.list();
			},
			rowClick(row) {
				this.row = row;
			},
			addchild(row, index){
				this.dialogVisible = true;
				this.Addsid = ["childadd", row];
			},
			edit(row, index) {
				this.dialogVisible = true;
				this.Addsid = ["bj", row];

				
			},
			reset() {
				this.menuname = '';

				// this.menuList({})
			},
			deletes(row, index) {
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(action => {
					if(action === 'confirm') {
						dictiondelete({id:row.id}).then((res) => {
							if(res.code == 200) {
								this.$notify({
									title: "提示",
									message: res.message,
									type: "success",
								});
								this.list();
							} else {
								this.$notify({
									title: "提示",
									message: res.message,
									type: "success",
								});
							}
						});

					}
				}).catch(() => {

				});

			},
		}

	}
</script>

<style scoped>
	@import url('../../common/css/mangementall.css');
	.querys {
		height: 30px;
		float: right;
		width: 200px;
		margin-top: 10px;
		margin-right: 10px;
	}
	
	>>>.el-input__inner {
		height: 30px;
		line-height: 30px;
		color: #606266;

		font-size: 14px;
	}
</style>